<template>
    <div class="accordion" id="carrier-parent">
        <div class="accordion-item">
            <h2 class="accordion-header" id="carrier">
                <button class="accordion-button" type="button" @click="$helper.toggleAccordion(($store.state.inClientAdmin ? 6 : 4), true);">
                    {{ ($store.state.transportationType === 'export') ? $helper.trans('Courier_call') : $helper.trans('Label_presenting') }}
                </button>
            </h2>
            <div id="carrier-content" class="accordion-collapse collapse" aria-labelledby="carrier" data-parent="#carrier-parent">
                <div class="accordion-body">
                    <carrier-information-block
                        v-if="$store.state.transportationType === 'export'"
                    ></carrier-information-block>
                    <label-presenting-block
                        v-else
                    ></label-presenting-block>

                    <div class="link-block">
                        <button type="button" @click="$helper.toggleAccordion(($store.state.inClientAdmin ? 5 : 3), true)" class="link link-left">{{ $helper.trans('Shipment_information') }}</button>
                        <button type="button" 
                            v-if="$store.state.$siteSettings.customer_payment_type === 'all'" 
                            @click="nextStep($store.state.inClientAdmin ? 7 : 5)" 
                            class="link link-right"
                        >
                            {{ $helper.trans('Additional_payment_options') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    methods: {
        nextStep(nextStep){
            console.log(nextStep);
            this.$helper.toggleAccordion(nextStep, true);
        }
    },
    watch: {
        '$store.state.carrierInfo': {
            handler(newValue) {
                this.$store.state.checkOutSteps.six = false;
            },
            deep: true
        }
    }
}
</script>
